import http from "@/utils/http";
let hr = "/hrApi";
let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  evaluatePersonnelList: (data) =>
    http.post(`${hr}/evaluatePersonnel/list`, data), // 外勤明细查询
  downTemplate: () =>
    http.get(`${hr}/evaluatePersonnel/downTemplate`, { responseType: "blob" }), // 下载模板
  importExcel: (data) =>
    http.post(`${hr}/evaluatePersonnel/importExcel`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }), // 导入
  quaGetEmployeeInfo: (data) =>
    http.post(`${host}/api/cic/index/getEmployeeInfo`, data), // 搜索人员

  evaluateQuestionsList: (data) =>
    http.post(`${hr}/evaluateQuestions/list`,data), // 查询考卷提型
  
  evaluatePersonnelDelete: (data) =>
    http.post(`${hr}/evaluatePersonnel/delete`, data), // 删除

  // 新增
  evaluatePersonnelAddOrUpdate: (data) =>
    http.post(`${hr}/evaluatePersonnel/addOrUpdate`, data),

  // 查询考评管理列表
  evaluateManageQueryList: (data) =>
    http.post(`${hr}/evaluateManage/queryManageList`, data),

  //查询考评管理明细列表
  evaluateManageList: (data) =>
    http.post(`${hr}/evaluateManage/list`, data),

  // 推送
  evaluateManagePush: (data) =>
    http.post(`${hr}/evaluateManage/push`, data),

  // 导出汇总
  evaluateManageExport: (data) =>
    http.post(`${hr}/evaluateManage/reportExcel`, data, {
      responseType: "blob",
    }),

  // 添加考评
  evaluateManageAdd: (data) =>
    http.post(`${hr}/evaluateManage/add`, data),

  // 查询结论
  evaluateManageQueryConclusion: (data) =>
    http.post(`${hr}/evaluateManage/queryConclusion`, data),

  // 潜在评级
  evaluateConclusionList: (data) =>
    http.post(`${hr}/evaluateConclusion/list`, data),

  // 考评对象
  evaluatePersonnelQueryDrop: (data) =>
    http.post(`${hr}/evaluatePersonnel/queryDrop`, data),

  // 详情
  evaluateManageDetail: (data) =>
    http.post(`${hr}/evaluateManage/detail`, data),

  // 结论详情
  evaluateManageQueryConclusionVo: (data) =>
    http.post(`${hr}/evaluateManage/queryConclusionVo`, data),

  // 考评活动列表
  evaluateActivityList: (data) =>
    http.post(`${hr}/evaluateActivity/list`, data),
  // 考评活动新增
  evaluateActivityAddOrUpdate: (data) =>
    http.post(`${hr}/evaluateActivity/addOrUpdate`, data),
  // 考评活动删除
  evaluateActivityDelete: (data) =>
    http.post(`${hr}/evaluateActivity/delete`, data),
  // 获取上次考评时间
  queryLastEvaluationTime: (data) =>
    http.post(`${hr}/evaluateManage/queryLastEvaluationTime`, data),
  // 查询靠谱剩余情况
  queryPersonnel: (data) =>
    http.post(`${hr}/evaluateManage/queryPersonnel`, data),
  // 考评活动维护推送
  evaluateActivityPush: (data) =>
    http.post(`${hr}/evaluateActivity/activityPush`, data),


  // 查询问卷
  evaluateQuestionsQueryList: (data) =>
    http.post(`${hr}/evaluateQuestions/list`, data),
  // 登录
  userFindUserAndName: (data) =>
    http.post(`${hr}/user/findUserAndName`, data),
  // 查询考评状态
  evaluateManageQueryEvaluaState: (data) =>
    http.post(`${hr}/evaluateManage/queryEvaluaState`, data),
  // 未考评推送
  pushNotEvaluated: (data) =>
    http.post(`${hr}/evaluateManage/pushNotEvaluated`, data),
};
